import { Skeleton } from '@components/ui/skeleton'
import { useContractorContext } from '@features/Contractor/ContractorContext'
import { ContractorEdit } from '@features/Contractor/Edit/ContractorEdit'
import { createFileRoute } from '@tanstack/react-router'

const ContractorEditSkeleton: React.FC = () => (
  <div className="space-y-6">
    <Skeleton className="h-10 w-64" />
    <Skeleton className="h-[500px] w-full" />
  </div>
)

const ContractorEditRoute: React.FC = () => {
  const { contractorId } = Route.useParams()
  const { data, isLoading } = useContractorContext()

  if (isLoading || !data) {
    return <ContractorEditSkeleton />
  }

  return <ContractorEdit data={data} contractorId={contractorId} />
}

export const Route = createFileRoute('/contractor/$contractorId/edit/')({
  component: ContractorEditRoute,
  staticData: {
    breadcrumb: 'Endre entreprenøropplysninger',
  },
})
